import * as React from 'react';
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationNext,
  PaginationPrevious,
} from '@/web/components/ui/pagination'
import type { PaginationPage } from '@/types';
import { PaginationNavItem } from '@/web/components/atoms/PaginationNavItem';
import { PageGridModal } from '@/web/components/molecules/PageGridModal';

export interface PaginationProps {
  pages: PaginationPage[];
  pageNo: number;
  totalCount: number;
  categoryId: string;
  subcategoryId?: string | null | undefined;
}

function getPrevUrl(categoryId: string, subcategoryId: string | null | undefined, pageNo: number): string {
  let prevPage = pageNo;
  if (prevPage > 1) {
    prevPage--;
  }
  if (subcategoryId) {
    return `/products/${categoryId}/${subcategoryId}?pageNo=${prevPage}`;
  }
  return `/products/${categoryId}?pageNo=${prevPage}`;
}

function getNextUrl(categoryId: string, subcategoryId: string | null | undefined, pageNo: number, maxPage: number): string {
  let nextPage = pageNo;
  if (nextPage < maxPage) {
    nextPage++;
  }
  if (subcategoryId) {
    return `/products/${categoryId}/${subcategoryId}?pageNo=${nextPage}`;
  }
  return `/products/${categoryId}?pageNo=${nextPage}`;
}

function getMaxPage(pages: PaginationPage[]) {
  if (pages.length) {
    const lastPage = pages[pages.length - 1];
    return lastPage.page;
  }
  return 1;
}

export function PaginationNav(props: PaginationProps): React.ReactElement {
  const { pageNo } = props;

  const maxPage = getMaxPage(props.pages);
  const prevUrl = getPrevUrl(props.categoryId, props.subcategoryId, pageNo);
  const nextUrl = getNextUrl(props.categoryId, props.subcategoryId, pageNo, maxPage);

  const showEllipsis = props.pages.length > 8;

  return (
    <div className="flex w-full min-w-0">
      <Pagination className="w-max min-w-full">
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious to={prevUrl}></PaginationPrevious>
          </PaginationItem>
          {
            showEllipsis ? (
              <>
                {props.pages.slice(0, 4).map(p => (
                  <PaginationNavItem
                    subcategoryId={props.subcategoryId}
                    categoryId={props.categoryId}
                    key={p.label}
                    page={p}
                  />
                ))}
                <PaginationItem>
                  <PageGridModal
                    pages={props.pages}
                    categoryId={props.categoryId}
                    subcategoryId={props.subcategoryId}
                  />
                </PaginationItem>
                {props.pages.slice(-4).map(p => (
                  <PaginationNavItem
                    subcategoryId={props.subcategoryId}
                    categoryId={props.categoryId}
                    key={p.label}
                    page={p}
                  />
                ))}
              </>
            ) : (
              props.pages.map(p => (
                <PaginationNavItem
                  subcategoryId={props.subcategoryId}
                  categoryId={props.categoryId}
                  key={p.label}
                  page={p}
                />
              ))
            )
          }
          <PaginationItem>
            <PaginationNext to={nextUrl}></PaginationNext>
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  )

}
